export const SituacaoCliente = {
  ATIVO: "Ativo",
  BLOQUEADO: "Bloqueado",
  INATIVO: "Inativo",
};

export function getStyleSituacaoCliente(situacao) {
  if (situacao === SituacaoCliente.BLOQUEADO || situacao === SituacaoCliente.INATIVO) {
    return { background: "#fdecea", color: "#c0392b" };
  }
  return { background: "#f5f5f5", color: "#333" };
}

export function getStyleFiltroCliente(situacao) {
  return { background: "#f8f9fa", color: "#212529" };
}

export function getTextColorSituacaoCliente(situacao) {
  if (situacao === SituacaoCliente.BLOQUEADO || situacao === SituacaoCliente.INATIVO) {
    return "#c0392b";
  }
  return "#212529";
}
